module.exports = __webpack_public_path__ + "img/logo.8c263259.png";